import React, { useEffect } from "react";
import { formatIDR } from "helpers/utils";
// import customInput from "../../../assets/scss/EmailSuiteOrder.module.scss"; // File sudah dihapus
import { useSelector, useDispatch } from "react-redux";
import { changeProductFromCart } from "features/common/layouts/cartSlice";

const EmailSuiteEccs = ({
  selectedProduct,
  selectedProductName,
  selectedPeriod,
  domain,
  setDomain,
  totalPrice,
  setTotalPrice,
  formValues,
  updateFormValues,
  configOptions,
  updateConfigOptions,
  customFields,
  updateCustomFields,
  handleProductChange,
  handlePeriodChange,
  handleAddToCart,
  product,
  validationManager,
  productManager,
}) => {
  const { productsList } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  // Get current product data
  const selectedProductData = product?.find(
    (data) => data.pid === parseInt(selectedProduct)
  );

  const selectedProductConfigOptions = selectedProductData
    ? selectedProductData.configoptions?.configoption || []
    : [];

  // Initialize config options and custom fields on component mount
  useEffect(() => {
    if (selectedProductData) {
      const newConfigOptions = {};
      const newCustomFields = {};

      // Extract config options
      selectedProductConfigOptions.forEach((config) => {
        newConfigOptions[config.name] = config.id;
      });

      // Extract custom fields
      if (selectedProductData.customfields?.customfield) {
        selectedProductData.customfields.customfield.forEach((field) => {
          newCustomFields[field.name] = field.id;
        });
      }

      updateConfigOptions(newConfigOptions);
      updateCustomFields(newCustomFields);

      // Set default values
      const defaultValues = {};
      selectedProductConfigOptions.forEach((config) => {
        config.options.option.forEach((option) => {
          if (config.name === "Akun") {
            defaultValues[config.name] = 1;
          } else {
            defaultValues[config.name] = 0;
          }
        });
      });

      updateFormValues(defaultValues);
    }
  }, [selectedProductData]);

  // Calculate price when form values change
  useEffect(() => {
    if (selectedProductData) {
      const newPrice = productManager.calculatePrice(
        selectedProductData,
        configOptions,
        selectedPeriod,
        formValues
      );
      setTotalPrice(newPrice);
    }
  }, [formValues, selectedPeriod, selectedProductData, configOptions]);

  const handleInputChange = (configName, value) => {
    const numValue = parseInt(value) || 0;
    updateFormValues({ [configName]: numValue });

    // Update cart if product is already in cart
    const existingCartItem = productsList.find(item => item.type === "emailSuite");
    if (existingCartItem && selectedProductData) {
      // Use productManager to build the complete payload
      const updatedFormValues = { ...formValues, [configName]: numValue };
      const productPayload = productManager.buildProductPayload(
        "eccs",
        selectedProductData,
        {
          ...updatedFormValues,
          selectedPeriod: selectedPeriod
        },
        configOptions,
        customFields
      );

      if (productPayload) {
        dispatch(changeProductFromCart(productPayload));
      }
    }
  };

  const handleDomainChange = (e) => {
    setDomain(e.target.value);
  };

  // Get available periods based on product pricing
  const getAvailablePeriods = () => {
    if (!selectedProductData || !selectedProductData.configoptions?.configoption) {
      return [];
    }

    const allPeriods = [
      { value: "monthly", label: "1 bulan" },
      { value: "quarterly", label: "3 bulan" },
      { value: "semiannually", label: "6 bulan" },
      { value: "annually", label: "1 tahun" },
      { value: "biennially", label: "2 tahun" },
      { value: "triennially", label: "3 tahun" },
    ];

    // Check if any config option has valid pricing for each period
    const availablePeriods = allPeriods.filter(period => {
      return selectedProductConfigOptions.some(config => {
        return config.options.option.some(option => {
          const pricing = option.pricing?.IDR?.[period.value];
          return pricing && parseFloat(pricing) > 0;
        });
      });
    });

    return availablePeriods.length > 0 ? availablePeriods : allPeriods;
  };

  const periodOptions = getAvailablePeriods();

  if (!selectedProductData) {
    return <div>Loading product data...</div>;
  }

  return (
    <div className="mt-4 mb-3">
      <h5 className="mb-3">ECCS Email Configuration</h5>

      {/* Product Selection */}
      <div className="mb-3">
        <label htmlFor="product" className="form-label">
          Pilih Produk
        </label>
        <select
          className="form-select"
          id="product"
          value={selectedProduct}
          onChange={(e) => {
            const selectedProd = product?.find(p => p.pid === parseInt(e.target.value));
            handleProductChange(e.target.value, selectedProd?.name || "");
          }}
        >
          {product?.map((prod) => (
            <option key={prod.pid} value={prod.pid}>
              {prod.name}
              </option>
          ))}
        </select>
      </div>

      {/* Period Selection and Configuration Options */}
      <div className="row">
        <div className="col-6 mb-3">
          <label htmlFor="period" className="form-label">
          Pilih Periode
        </label>
        <select
          className="form-select"
          id="period"
          value={selectedPeriod}
            onChange={(e) => handlePeriodChange(e.target.value)}
        >
            {periodOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
          </option>
            ))}
        </select>
      </div>

        {/* Configuration Options */}
      {selectedProductConfigOptions.map((config) =>
        config.options.option.map((option, i) => (
            <div key={i} className="col-6 mb-3">
              <label htmlFor={config.name} className="form-label">
              {config.name}
            </label>
              <div className="input-group">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    const currentValue = formValues[config.name] || 0;
                    const minValue = config.name === "Akun" ? 1 : 0;
                    if (currentValue > minValue) {
                      handleInputChange(config.name, currentValue - 1);
                    }
                  }}
                  disabled={(formValues[config.name] || 0) <= (config.name === "Akun" ? 1 : 0)}
                >
                  -
                </button>
            <input
              type="number"
                  min={config.name === "Akun" ? 1 : 0}
                  className="form-control text-center"
                  id={config.name}
                  value={formValues[config.name] || 0}
                  onChange={(e) => handleInputChange(config.name, e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    const currentValue = formValues[config.name] || 0;
                    handleInputChange(config.name, currentValue + 1);
                  }}
                >
                  +
                </button>
              </div>
          </div>
        ))
      )}
      </div>

      {/* Domain Input */}
      <div className="mb-3">
        <label htmlFor="domain" className="form-label">
          Domain (Wajib Diisi)
        </label>
        <input
          type="text"
          className="form-control"
          id="domain"
          placeholder="Contoh: example.com"
          value={domain}
          onChange={handleDomainChange}
        />
      </div>

      {/* Price Display */}
      <div className="row mb-3">
        <div className="col-6">
          <label className="form-label fw-bold">Harga</label>
        </div>
        <div className="col-6 text-end">
          <span className="fw-bold">{formatIDR(totalPrice)}</span>
        </div>
      </div>

      {/* Add to Cart Button */}
      <div className="text-center">
        <button
          type="button"
          className="btn btn-cta fw-bold py-2 rounded-5 mt-auto"
          onClick={handleAddToCart}
        >
          Tambahkan Ke Keranjang
        </button>
      </div>
    </div>
  );
};

export default EmailSuiteEccs;
